import { createHttpService } from '../ApiService';
import { normalizePaginatedResponse } from '../__shared/paginationUtils';
import { IScoreListQueryParams, IScoreListApiResponse, IScoreRecord } from './score.interfaces';
import isAppWithMock from 'src/utils/isAppWithMock';

export const useScoreService = () => {
  const httpAPI = createHttpService();
  const isMockData = isAppWithMock();

  const listScoreRecords = (
    params: IScoreListQueryParams
  ): Promise<IScoreListApiResponse> => {
    if (isMockData) {
      return Promise.resolve(
        normalizePaginatedResponse<IScoreRecord>(
          { data: [], count: 0 },
          'data'
        )
      );
    }

    const requestObj = {
      params: {
        page: Number(params.page) || 1,
        limit: Number(params.limit) || 10,
        ...(params.classId && { classId: params.classId }),
        ...(params.academicYear && { academicYear: params.academicYear }),
      },
    };

    return httpAPI.score
      .get<Record<string, unknown>>('/list', requestObj)
      .then((res) =>
        normalizePaginatedResponse<IScoreRecord>(
          (res as Record<string, unknown>) ?? {},
          'data'
        )
      )
      .catch((error) => {
        console.error('Error fetching score records:', error);
        throw error;
      });
  };

  return { listScoreRecords };
};
